module.exports = __webpack_public_path__ + "media/images/suppliers/histopathology-b936a2458ff0139aab7bcfdc5a9bb5b1.png";